<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="plus"></i> Cihaz Hareketi Oluştur
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body col-12">
    <form [formGroup]="deviceMovementForm">
        <div class="col-12">
            <label for="companyId">Tür</label>
            <div class="form-group">
                <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" formControlName="kindId">
                </ng-select>
                <div *ngIf="deviceMovementForm.get('kindId').invalid && deviceMovementForm.get('kindId').touched"
                    class="text-danger">
                    Tür zorunludur.
                </div>
            </div>
        </div>

        <div class="col-12">
            <label for="startDate">Hareket Tarihi</label>
            <div class="form-group">
                <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" formControlName="movementDate"
                    [setDate]="date"></ng2-flatpickr>
            </div>
        </div>

        <div class="col-12">
            <label for="description">Açıklama</label>
            <div class="form-group">
                <div class="input-group">
                    <textarea class="form-control" id="description" formControlName="description"></textarea>
                </div>
            </div>
        </div>

    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="deviceMovementForm.invalid" (click)="save()">
        Kaydet
    </button> <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
</div>